var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var debugStyle = function (_a) {
    var name = _a.name, color = _a.color, style = _a.style;
    return ({
        position: 'relative',
        border: "2px " + style + " " + color,
        '::before': {
            content: "'" + name + "'",
            position: 'absolute',
            padding: '1px 4px 1px',
            top: '-2px',
            left: '-2px',
            fontSize: '8px',
            fontWeight: 900,
            lineHeight: 1,
            letterSpacing: '1px',
            color: '#fff',
            background: color,
        },
    });
};
export var debugRoot = function () { return (__assign({}, debugStyle({ name: 'LAYOUT', color: 'cornflowerblue', style: 'solid' }), { padding: '8px', margin: '2px' })); };
export var debugArea = function () { return (__assign({}, debugStyle({ name: 'AREA', color: 'lightsalmon', style: 'dashed' }), { padding: '8px', margin: '2px' })); };
export var debugGap = function (_a) {
    var vertical = _a.vertical;
    return ({
        display: 'grid',
        background: '#ccc',
        '::before': __assign({ content: '"GAP"' }, (vertical
            ? {
                letterSpacing: '1px',
            }
            : {
                textOrientation: 'upright',
                writingMode: 'vertical-rl',
            }), { alignSelf: 'center', justifySelf: 'center', fontSize: '8px', fontWeight: 900, lineHeight: 0, color: '#fff' }),
    });
};
